import history from 'static/script/utils/history';

function MinimalRouter() {
    this.defineHashRoute = function (route, fn) {
        let re = new RegExp('^#' + route);
        let result = re.exec(location.hash);
        if (result) {
            fn.apply(this, result.slice(1));
        }
    };

    this.removeHashFromCurrentUrl = function () {
        history.replaceState({}, window.title, location.pathname + location.search);
    };


    this.getValueFromHashParam = function (param) {
        let hash = location.hash.charAt(0) === '#' ? location.hash.slice(1) : location.hash,
            pairArr,
            hashArr;

        if (!hash) {
            return undefined;
        }

        hashArr = hash.split('&');

        let hit = _.find(hashArr, function (pair) {
            pairArr = pair.split('=');
            if (pairArr[0] === param) {
                return true;
            }
            return false;
        });

        return hit ? hit.split('=')[1] : undefined;
    };
}

export default MinimalRouter;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/minimal-router.js